import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered"
  }, [_vm.inboundDeliveryOneClickAction.reference ? _c("h2", {
    staticClass: "order-reference"
  }, [_vm._v(" #" + _vm._s(_vm.inboundDeliveryOneClickAction.reference) + " ")]) : _vm._e(), _vm.loading.isLoading ? _c("div", {
    staticClass: "mt-4 loading-container"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  }), _vm._v(" " + _vm._s(_vm.loading.text) + " ")], 1) : _vm._e(), _vm.loading.isComplete ? _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? [_vm.inboundDeliveryOneClickAction.type === _vm.inboundDeliveryOneClickActionTypes.CUSTOMER_APPROVE.id ? _c("p", [_vm._v(" This order is now awaiting for administrator validation. Please verify payment terms approving the order from its detailled page. ")]) : _vm.inboundDeliveryOneClickAction.type === _vm.inboundDeliveryOneClickActionTypes.CANCEL.id ? _c("p", [_vm._v(" This order has been successfully cancelled. ")]) : _vm._e(), _vm.inboundDeliveryOneClickAction.type === _vm.inboundDeliveryOneClickActionTypes.CUSTOMER_APPROVE.id ? _c(VBtn, {
    staticClass: "dfwa-btn --small --with-dark-bg",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.goToInboundDeliveryDetails();
      }
    }
  }, [_vm._v(" View order ")]) : _vm._e()] : [_vm.inboundDeliveryOneClickAction.type === _vm.inboundDeliveryOneClickActionTypes.CUSTOMER_APPROVE.id ? _c("p", [_vm._v(" You approved this order. You'll be notified by e-mail of any change. ")]) : _vm.inboundDeliveryOneClickAction.type === _vm.inboundDeliveryOneClickActionTypes.CANCEL.id ? _c("p", [_vm._v(" Your order has been successfully cancelled. ")]) : _vm._e(), _c("p", [_vm._v("You can now close this browser tab")])]], 2) : _vm._e(), _vm.isRequestFinishedWithError ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.errorMessage))]), _c("p", [_vm._v("Sorry for the inconvenience. You can now close this browser tab")])]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };